"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FilterOperation = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
/*
 *  Copyright (c) Qwoach LLC 2022. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 14/2/2022
 */

var _require = require("./LogicalSymbols"),
  LogicalSymbols = _require.LogicalSymbols;
var NormalFormManager = require("./NormalFormManager");
var FilterOperation = exports.FilterOperation = Object.freeze({
  EQUAL: "==",
  LESS: "<",
  GREATER: ">",
  ARRAY_CONTAINS: "array-contains",
  ARRAY_CONTAINS_ANY: "array-contains-any",
  ARRAY_CONTAINS_ALL_CUSTOM: "array-contains-all",
  //WARNING: This is a custom operation that is not supported by Firestore
  OBJECT_CONTAINS_ANY_CUSTOM: "object-contains-any",
  //WARNING 1 and 2. 1:This is a custom operation that is not supported by Firestore. 2: Disjunctive form scales very quickly with this.
  OBJECT_CONTAINS_ALL_CUSTOM: "object-contains-all" //WARNING: This is a custom operation that is not supported by Firestore
});

module.exports = /*#__PURE__*/function () {
  function FilterOptions(field, operation, value) {
    (0, _classCallCheck2["default"])(this, FilterOptions);
    this.filterOptions = [];
    this.normalFormManager = new NormalFormManager();
    // this.setDebugEnabled(true)

    if (field, operation, value) {
      this.add(field, operation, value);
    }
  }
  (0, _createClass2["default"])(FilterOptions, [{
    key: "setDebugEnabled",
    value: function setDebugEnabled(isEnabled) {
      this.isDebugEnabled = isEnabled;
      this.normalFormManager.isDebugEnabled = isEnabled;
      return this;
    }
  }, {
    key: "merge",
    value: function merge(otherFilterOptions) {
      var filterOption = Object.assign(new FilterOptions(), this);
      otherFilterOptions.filterOptions.forEach(function (option) {
        filterOption.add(option.field, option.operation, option.value);
      });
      return filterOption;
    }
  }, {
    key: "reset",
    value: function reset() {
      this.filterOptions = [];
      return this;
    }
  }, {
    key: "add",
    value: function add(field, operation, value) {
      var _this = this;
      //remove duplicates by fieled and operation within the same "and" clause
      //this assumes the operations are in disjunctive normal form (DNF)
      // console.log("FilterOptions.add: field = ", field, " operation = ", operation, " value = ", value, ", this.filterOptions = ", this.filterOptions)

      var deduplicateStartIndex = this.filterOptions.length - 1;
      while (deduplicateStartIndex > 0 && this.filterOptions[deduplicateStartIndex] !== LogicalSymbols.AND_START && this.filterOptions[deduplicateStartIndex] !== LogicalSymbols.AND_END) {
        // console.log("FilterOptions.add: deduplicateStartIndex = ", deduplicateStartIndex, " this.filterOptions[deduplicateStartIndex] = ", this.filterOptions[deduplicateStartIndex])
        deduplicateStartIndex--;
      }
      this.filterOptions = this.filterOptions.filter(function (option, index) {
        return index <= deduplicateStartIndex || !_this._isDuplicateOptionInternal(option, field, operation);
      });
      this.filterOptions.push({
        field: field,
        operation: operation,
        value: value
      });
      return this;
    }
  }, {
    key: "_isDuplicateOptionInternal",
    value: function _isDuplicateOptionInternal(option, field, operation) {
      return option.field === field && option.operation === operation;
    }
  }, {
    key: "addArray",
    value: function addArray(field, value) {
      var operation;
      if (Array.isArray(value)) {
        operation = FilterOperation.ARRAY_CONTAINS_ANY;
      } else {
        operation = FilterOperation.ARRAY_CONTAINS;
      }
      this.add(field, operation, value);
      return this;
    }
  }, {
    key: "apply",
    value: function apply(ref) {
      var _this2 = this;
      // we need to expandFilterOptions before and after DNF conversion because DNF conversion can combine filterOptions that would require further expansion
      var filterOptions = this.expandFilterOptions(this.filterOptions);
      filterOptions = this.getFilterOptionsDNF(filterOptions);
      filterOptions = this.expandFilterOptions(filterOptions);
      this.log("FilterOptions.apply: filterOptions final = ", filterOptions);
      filterOptions.forEach(function (option) {
        if (option.field) {
          ref = ref.where(option.field, option.operation, option.value);
        } else {
          ref = _this2.invokeFnBySymbol(option, ref);
        }
      });
      return ref;
    }
  }, {
    key: "expandFilterOptions",
    value: function expandFilterOptions(filterOptions) {
      var _this3 = this;
      var filterItem = new FilterOptions();
      filterOptions.forEach(function (option) {
        if (option.field) {
          if (option.operation === FilterOperation.OBJECT_CONTAINS_ANY_CUSTOM) {
            _this3.performObjectContainsAny(filterItem, option);
          } else if (option.operation === FilterOperation.OBJECT_CONTAINS_ALL_CUSTOM) {
            _this3.performObjectContainsAll(filterItem, option);
          } else if (option.operation === FilterOperation.ARRAY_CONTAINS_ALL_CUSTOM) {
            _this3.performArrayContainsAllCustom(filterItem, option);
          } else if (option.operation === FilterOperation.ARRAY_CONTAINS_ANY) {
            _this3.performArrayContainsAny(filterItem, option);
          } else {
            filterItem.add(option.field, option.operation, option.value);
          }
        } else {
          filterItem.filterOptions.push(option);
        }
      });
      return filterItem.filterOptions;
    }
  }, {
    key: "performObjectContainsAny",
    value: function performObjectContainsAny(filterOptions, option) {
      var propsArray = option.value;
      var hasData = propsArray.length > 0;
      if (hasData) {
        filterOptions = filterOptions.orStart();
        propsArray.forEach(function (prop) {
          var field = "".concat(option.field, ".").concat(prop);
          filterOptions.add(field, FilterOperation.EQUAL, true);
        });
        filterOptions = filterOptions.orEnd();
      }
      return filterOptions;
    }
  }, {
    key: "performArrayContainsAny",
    value: function performArrayContainsAny(filterOptions, option) {
      var propsArray = option.value;
      var hasData = propsArray.length > 0;
      if (hasData) {
        filterOptions = filterOptions.orStart();
        propsArray.forEach(function (prop) {
          filterOptions.add(option.field, FilterOperation.ARRAY_CONTAINS, prop);
        });
        filterOptions = filterOptions.orEnd();
      }
      return filterOptions;
    }
  }, {
    key: "performObjectContainsAll",
    value: function performObjectContainsAll(filterOptions, option) {
      var propsArray = option.value;
      var hasData = propsArray.length > 0;
      if (hasData) {
        filterOptions = filterOptions.andStart();
        propsArray.forEach(function (prop) {
          var field = "".concat(option.field, ".").concat(prop);
          filterOptions.add(field, FilterOperation.EQUAL, true);
        });
        filterOptions = filterOptions.andEnd();
      }
      return filterOptions;
    }
  }, {
    key: "performArrayContainsAllCustom",
    value: function performArrayContainsAllCustom(filterOptions, option) {
      var valuesArray = option.value;
      var hasData = valuesArray.length > 0;
      if (hasData) {
        var value = valuesArray.sort().join("_");
        filterOptions.add(option.field, FilterOperation.ARRAY_CONTAINS, value);
      }
      return filterOptions;
    }
  }, {
    key: "isEmpty",
    value: function isEmpty() {
      return this.filterOptions.length === 0;
    }
  }, {
    key: "getFilterOptionsDNF",
    value: function getFilterOptionsDNF(filterOptions) {
      //convert to Disjunctive Normal Form
      var filterOptionsDNF = this.normalFormManager.convertToDNF(filterOptions, this.mergeOperationsOnSameFields.bind(this));
      return filterOptionsDNF;
    }
  }, {
    key: "mergeOperationsOnSameFields",
    value: function mergeOperationsOnSameFields(conjunctionArray) {
      var mergableOperations = [FilterOperation.ARRAY_CONTAINS];
      for (var i = 0; i < conjunctionArray.length; i++) {
        var option1 = conjunctionArray[i];
        if (mergableOperations.includes(option1.operation)) {
          for (var j = i + 1; j < conjunctionArray.length; j++) {
            var option2 = conjunctionArray[j];
            if (option2.field === option1.field) {
              //if option2 is array-contains-any or array-contains, merge values and set it to option1 (initially option1.value can be an array or single item)
              if (mergableOperations.includes(option2.operation)) {
                //one can add more sophisticated equality logic here for arrays+primitives. But this will do for now.
                if (JSON.stringify(option1.value) !== JSON.stringify(option2.value)) {
                  option1.value = Array.isArray(option1.value) ? option1.value : [option1.value];
                  var value2 = Array.isArray(option2.value) ? option2.value : [option2.value];
                  option1.operation = FilterOperation.ARRAY_CONTAINS_ALL_CUSTOM;
                  option1.value = option1.value.concat(value2);
                }
                conjunctionArray.splice(j, 1);
                j--;
              }
            }
          }
        }
      }
      return conjunctionArray;
    }
  }, {
    key: "orStart",
    value: function orStart() {
      this.filterOptions.push(LogicalSymbols.OR_START);
      return this;
    }
  }, {
    key: "andStart",
    value: function andStart() {
      this.filterOptions.push(LogicalSymbols.AND_START);
      return this;
    }
  }, {
    key: "orEnd",
    value: function orEnd() {
      this.filterOptions.push(LogicalSymbols.OR_END);
      return this;
    }
  }, {
    key: "andEnd",
    value: function andEnd() {
      this.filterOptions.push(LogicalSymbols.AND_END);
      return this;
    }
  }, {
    key: "invokeFnBySymbol",
    value: function invokeFnBySymbol(symbol, ref) {
      try {
        switch (symbol) {
          case LogicalSymbols.OR_START:
            return ref.orStart();
          case LogicalSymbols.AND_START:
            return ref.andStart();
          case LogicalSymbols.OR_END:
            return ref.orEnd();
          case LogicalSymbols.AND_END:
            return ref.andEnd();
          default:
            this.logWarn("FilterOptions.invokeFnBySymbol: unknown symbol = ", symbol);
            return ref;
        }
      } catch (e) {
        this.logWarn("FilterOptions.invokeFnBySymbol: e = ", e);
      }
      return ref;
    }
  }, {
    key: "hasOptionByName",
    value: function hasOptionByName(fieldName) {
      return this.filterOptions.some(function (option) {
        return option.field === fieldName;
      });
    }
  }, {
    key: "getOptionByName",
    value: function getOptionByName(fieldName) {
      return this.filterOptions.find(function (option) {
        return option.field === fieldName;
      });
    }
  }, {
    key: "log",
    value: function log() {
      if (this.isDebugEnabled) {
        var _console;
        (_console = console).log.apply(_console, arguments);
      }
    }
  }, {
    key: "logWarn",
    value: function logWarn() {
      if (this.isDebugEnabled) {
        var _console2;
        (_console2 = console).warn.apply(_console2, arguments);
      }
    }
  }]);
  return FilterOptions;
}();